//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Osteoporosis_Self_Screening_Tool_for_Asians",
  data() {
    return {
      form: {
        age: "",
        weight: "",
      },
      hasScore: false,
      disabled: false,
      
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "...";
      } else {
        let result =
          ((form.weight - form.age) * 0.2).toFixed(0)

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Osteoporosis_Self_Screening_Tool_for_Asians.vue